import React from 'react';

import { Event } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import {
  DateTimePickerProps, DateTimeValidationError, UseDateTimeFieldProps,
} from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { UseDateFieldProps } from '@mui/x-date-pickers/DateField';
import { DatePicker, DatePickerProps } from '@mui/x-date-pickers/DatePicker';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import {
  BaseSingleInputFieldProps,
  DateValidationError,
  FieldSection,
} from '@mui/x-date-pickers/models';
import { Dayjs } from 'dayjs';
import 'dayjs/locale/en-au';

import { ADAPTER_DAY_JS_LOCALE } from '../../utils/common/constants';
import { configureDayjs } from '../../utils/common/dayjsConfig';

configureDayjs();

interface ButtonFieldProps
  extends UseDateFieldProps<Dayjs>,
  BaseSingleInputFieldProps<
  Dayjs | null,
  Dayjs,
  FieldSection,
  DateValidationError
  > {
  setOpen?: React.Dispatch<React.SetStateAction<boolean>>;
}

const ButtonField = (props: ButtonFieldProps) => {
  const {
    setOpen,
    id,
    disabled,
    InputProps: { ref } = {},
    inputProps: { 'aria-label': ariaLabel } = {},
  } = props;

  return (
    <IconButton
      id={id}
      disabled={disabled}
      ref={ref}
      aria-label={ariaLabel}
      onClick={() => setOpen?.((prev) => !prev)}
    >
      <Event />
    </IconButton>
  );
};

export const IconDatePicker = (props: Omit<DatePickerProps<Dayjs>, 'open' | 'onOpen' | 'onClose'>) => {
  const [open, setOpen] = React.useState(false);

  const { slots } = props;

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={ADAPTER_DAY_JS_LOCALE}>
      <DatePicker
        slots={{ field: ButtonField, ...slots }}
        slotProps={{ field: { setOpen } as any }}
        {...props}
        open={open}
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
      />
    </LocalizationProvider>
  );
};

interface DatetimeButtonFieldProps
  extends UseDateTimeFieldProps<Dayjs>,
  BaseSingleInputFieldProps<
  Dayjs | null,
  Dayjs,
  FieldSection,
  DateTimeValidationError
  > {
  setOpen?: React.Dispatch<React.SetStateAction<boolean>>;
}

const DatetimeButtonField = (props: DatetimeButtonFieldProps) => {
  const {
    setOpen,
    id,
    disabled,
    InputProps: { ref } = {},
    inputProps: { 'aria-label': ariaLabel } = {},
  } = props;

  return (
    <IconButton
      id={id}
      disabled={disabled}
      ref={ref}
      aria-label={ariaLabel}
      onClick={() => setOpen?.((prev) => !prev)}
    >
      <Event />
    </IconButton>
  );
};

export const IconDateTimePicker = (props: Omit<DateTimePickerProps<Dayjs>, 'open' | 'onOpen' | 'onClose'>) => {
  const [open, setOpen] = React.useState(false);

  const { slots } = props;

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={ADAPTER_DAY_JS_LOCALE}>
      <DateTimePicker
        slots={{ field: DatetimeButtonField, ...slots }}
        slotProps={{ field: { setOpen } as any }}
        {...props}
        open={open}
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
      />
    </LocalizationProvider>
  );
};
